import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {OrderFilterService} from '@shared/services/order-filter.service';
import {NotificationService} from "@shared/services/notification.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {debounceTime} from "rxjs/operators";
import {BaseResponse} from "@core/models/base-response.model";
import {MESSAGE_CODE} from "@shared/constants/message-code.constant";
import {CommonUtils} from "@shared/utils/utils";
import {Mode} from "@shared/enums/mode.enum";
import {OrderModel} from "@modules/administration/orders/interfaces/order.model";
import {FilterOrderRequest} from "@modules/administration/orders/interfaces/order.request";
import {OrderService} from "@modules/administration/orders/services/order.service";
import {OrderConstant} from "@modules/administration/orders/order.constant";
import {differenceInCalendarDays} from "date-fns";
import {EditOrderComponent} from "@modules/administration/orders/components/edit-order/edit-order.component";
import {PrintOrderComponent} from "@modules/administration/orders/components/print-order/print-order.component";

@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit, OnDestroy {
    readonly tableConfig = OrderConstant.TABLE_CONFIG;

    orderList: OrderModel[] = [];
    filter: FilterOrderRequest = new FilterOrderRequest();
    isLoadingPaid: boolean;
    isLoadingShipped: boolean;
    private filter$ = new Subject<any>();
    private destroy$ = new Subject<void>();
    totalAmount: number;
    totalOrder: number;
    selectedList = [];
    invoices: OrderModel[] = [];
    constructor(
        private notiService: NotificationService,
        private orderService: OrderService,
        private modalService: NzModalService,
        private orderFilterService: OrderFilterService,
    ) {
    }

    ngOnInit(): void {
        this.filter$
            .pipe(debounceTime(500))
            .subscribe(() => this.getList(true));

        this.orderFilterService.orderId.pipe(
            takeUntil(this.destroy$)
        ).subscribe(orderId => {
            this.filter.orderId = orderId;
            this.getList(true);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.orderFilterService.clear();
    }

    getList(refresh: boolean = false, sort?: { sortBy: string, ascOrDesc: string }) {
        this.tableConfig.loading = true;
        if (refresh) {
            this.tableConfig.pageIndex = 1;
        }
        this.filter.pageSize = this.tableConfig.pageSize;
        this.filter.pageNumber = this.tableConfig.pageIndex;
        if (sort) {
            this.filter.sortBy = sort.sortBy;
            this.filter.ascOrDesc = sort.ascOrDesc;
        }
        this.orderService.getList(this.filter).subscribe((res: BaseResponse<any, any>) => {
            if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
                // this.orderList = res.data.content;
                this.tableConfig.total = res.data.totalElements;
                let arr = []
                res.data.content.map(o => {
                    if (o.product.includes("#")) {
                        o.productView = this.parseStringProduct(o.product)
                    }else {
                        o.productView = o.product
                    }
                    arr.push(o)
                    return arr;
                })
                this.orderList = [...arr];
            }
            this.tableConfig.loading = false
        }, error => {
            this.tableConfig.loading = false
        }, () => this.tableConfig.loading = false);

    }

    filterChange($event) {
        this.orderFilterService.clear();
        this.filter$.next($event);
    }

    // reload() {
    //   this.filter = new FilterUserRequest();
    //   this.getList(true);
    // }


    add() {
        this.edit(null);
    }

    edit(data: any) {
        const modal = this.modalService.create({
            nzTitle: data ? 'Chỉnh sửa thông tin' : 'Thêm mới',
            nzWidth: CommonUtils.getModalSize(window),
            nzContent: EditOrderComponent,
            nzComponentParams: {
                data: data,
                mode: data ? Mode.EDIT : Mode.ADD
            },
            nzFooter: null
        });
        modal.afterClose.subscribe(result => {
            if (result) this.getList()
        })
    }

    delete(data: any) {
        this.orderService.deleteOrder(data).subscribe((res: BaseResponse<any, any>) => {
            if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
                this.notiService.success("Xóa thành công");
                this.getList();
            }
        }, error => {
            this.notiService.error(BaseResponse.getMessage(error));
        });
    }


    disabledToDate = (current: Date): boolean =>
        differenceInCalendarDays(current, this.filter.fromDate) < 0;
    disabledFromDate = (current: Date): boolean =>
        differenceInCalendarDays(current, this.filter.toDate) > 0;


    bookBe(data: any) {
        // Open a new window with the specified URL
        const newWindow = window.open('https://giaohang.be.com.vn/', '_blank');

    }

    printOrder(data: any) {
        console.log('data', data)
        this.invoices = [data];
        console.log('invoices',this.invoices)
        const modal = this.modalService.create({
            nzTitle: '',
            nzWidth: CommonUtils.getModalSize(window),
            nzContent: PrintOrderComponent,
            nzComponentParams: {
                data: this.invoices,
            },
            nzFooter: null
        });
        modal.afterClose.subscribe(result => {
            this.invoices = [];
            if (result) {
                this.orderService.updatePrint(data.id).subscribe();
                this.getList();
            }
        });
    }

    clickSwitchPaid(data: any) {
        if (data.paid) {
            data.paid = 1;
        } else {
            data.paid = 0;
        }
        this.isLoadingPaid = true;
        this.orderService.edit(data).subscribe((res: BaseResponse<any, any>) => {
            if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
                this.notiService.success(res.message);
                this.getList(true);
            } else this.notiService.error(BaseResponse.getMessage(res));
            this.isLoadingPaid = false;
        }, error => {
            this.isLoadingPaid = false;
            this.notiService.error(BaseResponse.getMessage(error));
        });
    }

    clickSwitchShipped(data: any) {
        const prevValue = data.isShipped;
        this.isLoadingShipped = true;
        this.orderService.updateShipped(data.id).subscribe((res: BaseResponse<any, any>) => {
            if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
                this.notiService.success(res.message);
                this.getList(true);
            } else {
                data.isShipped = prevValue;
                this.notiService.error(BaseResponse.getMessage(res));
            }
            this.isLoadingShipped = false;
        }, error => {
            data.isShipped = prevValue;
            this.isLoadingShipped = false;
            this.notiService.error(BaseResponse.getMessage(error));
        });
    }

    parseStringProduct(input: string): string {
        const regex = /([^|#]+)\|(\d+)\|(\d+)/g;
        let match: RegExpExecArray | null;
        let product = "";
        while ((match = regex.exec(input)) !== null) {
            product += parseInt(match[2], 10) + ' ' + match[1] + ': ' + parseInt(match[3], 10) + " ; ";
        }
        return product;
    }
    doPrint() {
        if (this.selectedList.length === 0) {
            this.notiService.error('Chọn đơn hàng bạn muốn in');
            return;
        }

        this.invoices = [...this.selectedList]; // clone selected list

        const modal = this.modalService.create({
            nzTitle: '',
            nzWidth: CommonUtils.getModalSize(window),
            nzContent: PrintOrderComponent,
            nzComponentParams: {
                data: this.invoices,
            },
            nzFooter: null
        });

        modal.afterClose.subscribe(result => {
            if (result) {
                this.invoices.forEach(o => this.orderService.updatePrint(o.id).subscribe());
                this.invoices = [];
                this.getList();
            }
        });
    }

}

